import {
  httpClient,
  handleErrorResp,
  httpFileUpload,
  getToken,
} from "../UtilService";
import {
  ICustomers,
  IStandardAPIResponse,
  ICardHolder,
  ICardHolderAssign,
  ICardHolderSearch,
  ISearchTransactions,
  IAccessReportVM,
  IEventSourceSearch,
  ICustomerEventSource,
  ISearchTempRhDetails,
  IPowerDetailsResp,
  ISearchCCTVImage,
  ICCTVImage,
  IUpTime,
  IDedicatedPduRemarks,
  IMinimumCommitted,
  ITempRhDetails,
  IAuthorizedContacts,
  IServiceDetails,
  IPreviousMeeting,
  IAssignedEscalationMatrix,
  IDataCenter,
  IActivityUpdate,
  ICustomerRackStatus,
  ICustomerReport,
  ICustomerReportWorkFlowLog,
  IMiscellaneousFile,
  ICustomerConfig,
  ISearchUpTime,
  IPowerReportConfigurations,
  ITempRhReadings,
  IAssignCardHolder,
  IAccessLogsConfiguration,
  IcustomerRackStatusObj,
  ITempAndRhPageConfiguration,
  ITempAndRhPageWiseRemarks,
  IRHSTicketDetails,
  ICustomerReportEmails,
  IPreviousMeetingEmail,
  IPreviousMeetingActionItemsSearch,
} from "../../vm";
import { API_URL } from "../../components/common/Constants";

export async function getAllCustomers(search?: {
  search?: string;
  customerId?: string;
  offset?: number;
  limit?: number;
  showCircuitIdAndDc?: boolean;
  showReportStatus?: boolean;
  customerReportStatus?: number;
  date?: Date;
  datacenterIds?: string;
  showPagination?: boolean;
}): Promise<IStandardAPIResponse<any>> {
  try {
    let res = await httpClient<any>(`customers`, "POST", search);
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function getCardHolders(
  serchObj: ICardHolderSearch
): Promise<IStandardAPIResponse<Array<any>>> {
  try {
    let res = await httpClient<Array<any>>(`card-holders`, "GET", serchObj);
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function getAssignCardHolders(serchObj: {
  customerId: string;
  offset: number;
  limit: number;
}): Promise<IStandardAPIResponse<Array<IAssignCardHolder>>> {
  try {
    let res = await httpClient<Array<IAssignCardHolder>>(
      `assign-card-holders`,
      "GET",
      serchObj
    );
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function unAssignACardHolder(
  id: string
): Promise<IStandardAPIResponse<IAssignCardHolder>> {
  try {
    let res = await httpClient<IAssignCardHolder>(
      `card-holders/unassign/${id}`,
      "DELETE"
    );
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function assignCardHolders(data: {
  customerId: string;
  cardholderId: string;
  datacenterIds: string[];
}): Promise<IStandardAPIResponse<IAssignCardHolder>> {
  try {
    let res = await httpClient<IAssignCardHolder>(
      `card-holders/assign`,
      "PATCH",
      data
    );
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function getCustomerTransaction(
  search: ISearchTransactions
): Promise<IStandardAPIResponse<IAccessReportVM>> {
  try {
    let res = await httpClient<IAccessReportVM>(`access-logs`, "GET", search);
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function getCustomerEventSources(
  serchObj: IEventSourceSearch
): Promise<IStandardAPIResponse<Array<ICustomerEventSource>>> {
  try {
    let res = await httpClient<Array<ICustomerEventSource>>(
      `customer-event-sources`,
      "GET",
      serchObj
    );
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function getEventSources(
  serchObj: IEventSourceSearch
): Promise<IStandardAPIResponse<Array<any>>> {
  try {
    let res = await httpClient<Array<any>>(`event-sources`, "GET", serchObj);
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function updateCustomerEventSources(
  data: ICustomerEventSource
): Promise<IStandardAPIResponse<ICustomerEventSource>> {
  try {
    let res = await httpClient<ICustomerEventSource>(
      `customer-event-sources`,
      "PATCH",
      data
    );
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function deleteCustomerEventSources(
  data: ICustomerEventSource
): Promise<IStandardAPIResponse<ICustomerEventSource>> {
  try {
    let res = await httpClient<ICustomerEventSource>(
      `customer-event-sources/${data._id}`,
      "DELETE"
    );
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function getAccessLogsConfiguration(search: {
  customerId: string;
}): Promise<IStandardAPIResponse<Array<IAccessLogsConfiguration>>> {
  try {
    let res = await httpClient<Array<IAccessLogsConfiguration>>(
      `access-logs-configuration`,
      "GET",
      search
    );
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function updateAccessLogsConfiguration(
  data: IAccessLogsConfiguration
): Promise<IStandardAPIResponse<IAccessLogsConfiguration>> {
  try {
    let res = await httpClient<IAccessLogsConfiguration>(
      `update-access-logs-configuration`,
      "PATCH",
      data
    );
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function getCustomerTempHumidity(
  search: ISearchTransactions
): Promise<IStandardAPIResponse<any>> {
  try {
    let res = await httpClient<any>(`temp-rh`, "GET", search);
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function getCustomerTempHumidityDetails(
  search: ISearchTempRhDetails
): Promise<IStandardAPIResponse<any>> {
  try {
    let res = await httpClient<any>(`temp-rh/details`, "GET", search);
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function updateCustomerTempHumidityDetails(
  data: ITempRhDetails
): Promise<IStandardAPIResponse<any>> {
  try {
    let res = await httpClient<any>(`temp-rh/${data.id}`, "PATCH", data);
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function updateTempAndHumidity(
  data: ITempRhReadings
): Promise<IStandardAPIResponse<ITempRhReadings>> {
  try {
    let res = await httpClient<ITempRhReadings>(
      `update-temp-rh-readings-day`,
      "PATCH",
      data
    );
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function addTempAndRhPage(
  data: ITempAndRhPageConfiguration
): Promise<IStandardAPIResponse<ITempAndRhPageConfiguration>> {
  try {
    let res = await httpClient<ITempAndRhPageConfiguration>(
      `temp-rh-pages`,
      "PUT",
      data
    );
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function updateTempAndRhPage(
  data: ITempAndRhPageConfiguration
): Promise<IStandardAPIResponse<ITempAndRhPageConfiguration>> {
  try {
    let res = await httpClient<ITempAndRhPageConfiguration>(
      `temp-rh-pages/${data._id}`,
      "PATCH",
      data
    );
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function deleteTempAndRhPage(
  id: string
): Promise<IStandardAPIResponse<ITempAndRhPageConfiguration>> {
  try {
    let res = await httpClient<ITempAndRhPageConfiguration>(
      `temp-rh-pages/${id}`,
      "DELETE",
    );
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function getTempRHPageDetails(
  searchObj: { tempRhPageId: string }
): Promise<IStandardAPIResponse<ITempAndRhPageConfiguration>> {
  try {
    let res = await httpClient<ITempAndRhPageConfiguration>(`temp-rh-pages/${searchObj.tempRhPageId}`, "GET");
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function getSensorsByFloorOrQuadrant(
  searchObj: { customerId: string, datacenterId: string, floorId: string, quadrantId?: string, isFilter: boolean }
): Promise<IStandardAPIResponse<any>> {
  try {
    let res = await httpClient<any>(`temp-rh/sensors`, "GET", searchObj);
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function getTempAndRhRemarks(searchObj: {
  tempRhPageId: string,
  date: Date | string,
  customerId?: string,
  datacenterId?: string,
}): Promise<IStandardAPIResponse<Array<ITempAndRhPageWiseRemarks>>> {
  try {
    let res = await httpClient<Array<ITempAndRhPageWiseRemarks>>(
      `temp-rh-remarks`,
      "GET",
      searchObj
    );
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}

export async function addTempAndRhRemarks(
  data: ITempAndRhPageWiseRemarks
): Promise<IStandardAPIResponse<ITempAndRhPageWiseRemarks>> {
  try {
    let res = await httpClient<ITempAndRhPageWiseRemarks>(`temp-rh-remarks`, "PUT", data);
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}

export async function updateTempAndRhRemarks(
  data: ITempAndRhPageWiseRemarks
): Promise<IStandardAPIResponse<ITempAndRhPageWiseRemarks>> {
  try {
    let res = await httpClient<ITempAndRhPageWiseRemarks>(`temp-rh-remarks/${data._id}`, "PATCH", data);
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}

export async function deleteTempAndRhRemarks(
  data: ITempAndRhPageWiseRemarks
): Promise<IStandardAPIResponse<ITempAndRhPageWiseRemarks>> {
  try {
    let res = await httpClient<ITempAndRhPageWiseRemarks>(`temp-rh-remarks/${data._id}`, "DELETE", data);
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}

export async function getCustomerPowerPduReport(
  search: ISearchTransactions
): Promise<IStandardAPIResponse<any>> {
  try {
    let res = await httpClient<any>(`power-readings`, "GET", search);
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function getCustomerDatacenters(search: {
  customerId: string;
  isLite?: boolean;
}): Promise<IStandardAPIResponse<Array<any>>> {
  try {
    let res = await httpClient<Array<any>>(
      `power-readings/datacenters`,
      "GET",
      search
    );
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function getCustomerMinimumCommittedPower(search: {
  customerId: string;
  datacenterId?: string;
}): Promise<IStandardAPIResponse<Array<any>>> {
  try {
    let res = await httpClient<Array<any>>(
      `power-readings/minimum-committed-power`,
      "GET",
      search
    );
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function updateCustomerMinimumCommittedPower(
  data: IMinimumCommitted[]
): Promise<IStandardAPIResponse<Array<IMinimumCommitted>>> {
  try {
    let res = await httpClient<Array<IMinimumCommitted>>(
      `power-readings/minimum-committed-power`,
      "PATCH",
      data
    );
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function updateCustomerDedicatedPduRemarks(
  data: IDedicatedPduRemarks
): Promise<IStandardAPIResponse<any>> {
  try {
    let res = await httpClient<any>(
      `power-readings/dedicated-pdu-remarks`,
      "PATCH",
      data
    );
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function updateCustomerRackwisePdu(
  data: any
): Promise<IStandardAPIResponse<any>> {
  try {
    let res = await httpClient<any>(
      `power-readings/rackwised-pdu-values`,
      "PATCH",
      data
    );
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function updateCustomerDedicatedPdu(
  data: any
): Promise<IStandardAPIResponse<any>> {
  try {
    let res = await httpClient<any>(
      `power-readings/dedicated-pdu-values`,
      "PATCH",
      data
    );
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function getPowerReportConfigurations(search: {
  customerId: string;
}): Promise<IStandardAPIResponse<Array<IPowerReportConfigurations>>> {
  try {
    let res = await httpClient<Array<IPowerReportConfigurations>>(
      `power-report-configurations`,
      "GET",
      search
    );
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function updatePowerReportConfigurations(
  data: IPowerReportConfigurations
): Promise<IStandardAPIResponse<IPowerReportConfigurations>> {
  try {
    let res = await httpClient<IPowerReportConfigurations>(
      `power-report-configurations`,
      "PATCH",
      data
    );
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function getCustomerRatedDetailsByDC(search: {
  customerId: string;
}): Promise<IStandardAPIResponse<{ [key: string]: boolean }>> {
  try {
    let res = await httpClient<{ [key: string]: boolean }>(
      `power-readings/datacenters/rated-details`,
      "GET",
      search
    );
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function getCCTVImages(
  search: ISearchCCTVImage
): Promise<IStandardAPIResponse<Array<ICCTVImage>>> {
  try {
    let res = await httpClient<Array<ICCTVImage>>(`cctv-images`, "GET", search);
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function addCCTVImage(
  data: ICCTVImage
): Promise<IStandardAPIResponse<ICCTVImage>> {
  try {
    let res = await httpClient<ICCTVImage>(`cctv-images`, "PUT", data);
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}
export async function updateCCTVImage(
  data: ICCTVImage
): Promise<IStandardAPIResponse<ICCTVImage>> {
  try {
    let res = await httpClient<ICCTVImage>(
      `cctv-images/${data._id}`,
      "PATCH",
      data
    );
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}
export async function deleteCCTVImage(
  id: string
): Promise<IStandardAPIResponse<ICCTVImage>> {
  try {
    let res = await httpClient<ICCTVImage>(`cctv-images/${id}`, "DELETE");
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function getUpTimeDetails(
  search: ISearchUpTime
): Promise<IStandardAPIResponse<Array<IUpTime>>> {
  try {
    let res = await httpClient<Array<IUpTime>>(`uptimes`, "GET", search);
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function updateUpTime(
  data: IUpTime[]
): Promise<IStandardAPIResponse<Array<IUpTime>>> {
  try {
    let res = await httpClient<Array<IUpTime>>(`uptimes`, "PATCH", data);
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function uptimeFileUpload(
  file: any,
  data: any
): Promise<IStandardAPIResponse<any>> {
  try {
    let res = await httpFileUpload<any>(
      `import-uptime/${data.datacenterId}`,
      "POST",
      {
        file,
        data,
      }
    );
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function getCustomerTicketCount(
  search: any
): Promise<IStandardAPIResponse<any>> {
  try {
    let res = await httpClient<any>(`service-now-ticket-count`, "GET", search);
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}
export async function syncCustomerTicketCount(
  search: any
): Promise<IStandardAPIResponse<any>> {
  try {
    let res = await httpClient<any>(
      `service-now-ticket-count/sync`,
      "GET",
      search
    );
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}
export async function updateCustomerTicketCount(
  data: any
): Promise<IStandardAPIResponse<any>> {
  try {
    let res = await httpClient<any>(
      `service-now-ticket-count/update`,
      "PATCH",
      data
    );
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}
export async function getCustomers(
  customerIds: string[]
): Promise<IStandardAPIResponse<Array<ICustomers>>> {
  try {
    let res = await httpClient<Array<ICustomers>>(`customers-list`, "GET", {
      customerIds,
    });
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}
export async function getCustomerTicketDetails(
  search: any
): Promise<IStandardAPIResponse<any>> {
  try {
    let res = await httpClient<any>(`service-now-report`, "GET", search);
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function getCustomerTicketDetailsExcel(
  obj: any
): Promise<Response> {
  try {
    const res: any = await fetch(
      `${API_URL}service-now-report/excel?datacenterId=${obj.datacenterId}&customerId=${obj.customerId}&startDate=${obj.startDate}&endDate=${obj.endDate}&type=${obj.type}`,
      {
        method: "GET",
        credentials: 'include', // Enable credentials for CORS
        headers: { at: getToken() },
      }
    );
    return res;
  } catch (err: any) {
    return err;
  }
}
export async function getCustomerTicketAllDetailsExcel(
  obj: any
): Promise<Response> {
  try {
    const res: any = await fetch(
      `${API_URL}service-now-report/all/excel?datacenterId=${obj.datacenterId || ""
      }&customerId=${obj.customerId || ""}&startDate=${obj.startDate || ""
      }&endDate=${obj.endDate || ""}&types=${obj.types || ""}`,
      {
        method: "GET",
        credentials: 'include', // Enable credentials for CORS
        headers: { at: getToken() },
      }
    );
    return res;
  } catch (err: any) {
    return err;
  }
}

export async function getCustomerRHSTicketDetails(
  search: any
): Promise<IStandardAPIResponse<Array<IRHSTicketDetails>>> {
  try {
    let res = await httpClient<Array<IRHSTicketDetails>>(`rhs-tickets/details`, "GET", search);
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function addCustomerRHSTicket(
  data: IRHSTicketDetails
): Promise<IStandardAPIResponse<IRHSTicketDetails>> {
  try {
    let res = await httpClient<IRHSTicketDetails>(
      `rhs-tickets`,
      "PUT",
      data
    );
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function updateCustomerRHSTicket(
  data: any
): Promise<IStandardAPIResponse<any>> {
  try {
    let res = await httpClient<any>(
      `rhs-tickets/${data._id}`,
      "PATCH",
      data
    );
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function deleteCustomerRHSTicket(
  id: string
): Promise<IStandardAPIResponse<any>> {
  try {
    let res = await httpClient<any>(
      `rhs-tickets/${id}`,
      "DELETE"
    );
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function getAuthorizedContacts(search: {
  customerId: string;
  datacenterId?: string;
  search?: string;
}): Promise<IStandardAPIResponse<Array<IAuthorizedContacts>>> {
  try {
    let res = await httpClient<Array<IAuthorizedContacts>>(
      `authorized-contacts`,
      "GET",
      search
    );
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function addAuthorizedContacts(
  data: IAuthorizedContacts
): Promise<IStandardAPIResponse<IAuthorizedContacts>> {
  try {
    let res = await httpClient<IAuthorizedContacts>(
      `authorized-contacts`,
      "PUT",
      data
    );
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function updateAuthorizedContacts(
  data: IAuthorizedContacts
): Promise<IStandardAPIResponse<IAuthorizedContacts>> {
  try {
    let res = await httpClient<IAuthorizedContacts>(
      `authorized-contacts/${data._id}`,
      "PATCH",
      data
    );
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function deleteAuthorizedContacts(
  data: IAuthorizedContacts
): Promise<IStandardAPIResponse<IAuthorizedContacts>> {
  try {
    let res = await httpClient<IAuthorizedContacts>(
      `authorized-contacts/${data._id}`,
      "DELETE"
    );
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function getServiceDetails(search: {
  customerId: string;
  datacenterId?: string;
}): Promise<IStandardAPIResponse<Array<IServiceDetails>>> {
  try {
    let res = await httpClient<Array<IServiceDetails>>(
      `service-details`,
      "GET",
      search
    );
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function addServiceDetails(
  data: IServiceDetails
): Promise<IStandardAPIResponse<IServiceDetails>> {
  try {
    let res = await httpClient<IServiceDetails>(`service-details`, "PUT", data);
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function updateServiceDetails(
  data: IServiceDetails
): Promise<IStandardAPIResponse<IServiceDetails>> {
  try {
    let res = await httpClient<IServiceDetails>(
      `service-details/${data._id}`,
      "PATCH",
      data
    );
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function deleteServiceDetails(
  data: IServiceDetails
): Promise<IStandardAPIResponse<IServiceDetails>> {
  try {
    let res = await httpClient<IServiceDetails>(
      `service-details/${data._id}`,
      "DELETE"
    );
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function getPreviousMeetings(search: {
  customerId?: string;
  status?: string[];
  startDate?: Date | string;
  endDate?: Date | string;
  ignoreDateRange?: boolean;
  cemIds?: string[];
  customerIds?: string[];
  sortBy?: string;
  sortOrder?: string
}): Promise<IStandardAPIResponse<Array<IPreviousMeeting>>> {
  try {
    let res = await httpClient<Array<IPreviousMeeting>>(
      `previous-meetings`,
      "POST",
      // "GET",
      search
    );
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function getPreviousMeetingsExcel(search: any): Promise<Response> {
  try {
    let res = await fetch(`${API_URL}previous-meetings`, {
      method: "POST",
      credentials: 'include', // Enable credentials for CORS
      headers: {
        "Content-Type": "application/json; charset=utf-8",
        at: getToken()
      },
      body: JSON.stringify({ ...search, isExport: true })
    });
    return res;
  } catch (err: any) {
    return err;
  }
}

export async function addPreviousMeeting(
  data: IPreviousMeeting
): Promise<IStandardAPIResponse<IPreviousMeeting>> {
  try {
    let res = await httpClient<IPreviousMeeting>(
      `previous-meetings`,
      "PUT",
      data
    );
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function updatePreviousMeeting(
  data: IPreviousMeeting
): Promise<IStandardAPIResponse<IPreviousMeeting>> {
  try {
    let res = await httpClient<IPreviousMeeting>(
      `previous-meetings/${data._id}`,
      "PATCH",
      data
    );
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function deletePreviousMeeting(
  data: IPreviousMeeting
): Promise<IStandardAPIResponse<IPreviousMeeting>> {
  try {
    let res = await httpClient<IPreviousMeeting>(
      `previous-meetings/${data._id}`,
      "DELETE"
    );
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function getPreviousMeetingParticipants(search: {
  customerId: string;
  type: string;
  search: string;
}): Promise<IStandardAPIResponse<Array<IPreviousMeeting>>> {
  try {
    let res = await httpClient<Array<IPreviousMeeting>>(
      `previous-meetings/participants`,
      "GET",
      search
    );
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function sendPreviousMeetingEmail(
  { file, ...data }: IPreviousMeetingEmail
): Promise<IStandardAPIResponse<any>> {
  try {
    // let res = await httpClient<any>(
    let res = await httpFileUpload<any>(
      `previous-meetings/send-email`,
      "POST",
      { data, file }
    );
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function exportPreviousMeetingPDF(searchObj: IPreviousMeetingActionItemsSearch): Promise<Response> {
  try {
    let res = await fetch(
      `${API_URL}previous-meetings/export-pdf`,
      {
        method: "POST",
        credentials: 'include', // Enable credentials for CORS
        headers: {
          at: getToken(),
          "Content-Type": "application/json; charset=utf-8",
        },
        body: JSON.stringify(searchObj),
      }
    );
    return res;
  } catch (err: any) {
    return err;
  }
}

export async function getAssignedEscalationMatrix(search: {
  customerId: string;
  type?: string;
}): Promise<IStandardAPIResponse<Array<IAssignedEscalationMatrix>>> {
  try {
    let res = await httpClient<Array<IAssignedEscalationMatrix>>(
      `assigned-escalation-matrixes`,
      "GET",
      search
    );
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function assignOrDeAssignEscalationMatrix(
  data: IAssignedEscalationMatrix
): Promise<IStandardAPIResponse<IAssignedEscalationMatrix>> {
  try {
    let res = await httpClient<IAssignedEscalationMatrix>(
      `assigned-escalation-matrixes`,
      "PATCH",
      data
    );
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function getDatacentersForACustomer(data: {
  customerId: string;
}): Promise<IStandardAPIResponse<Array<any>>> {
  try {
    let res = await httpClient<Array<any>>(`customer-datacenters`, "GET", data);
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function getActivityUpdates(search: {
  customerId: string;
  date: Date | string;
}): Promise<IStandardAPIResponse<Array<IActivityUpdate>>> {
  try {
    let res = await httpClient<Array<IActivityUpdate>>(
      `activity-updates`,
      "GET",
      search
    );
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function addActivityUpdates(
  data: IActivityUpdate
): Promise<IStandardAPIResponse<IActivityUpdate>> {
  try {
    let res = await httpClient<IActivityUpdate>(
      `activity-updates`,
      "PUT",
      data
    );
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function updateActivityUpdates(
  data: IActivityUpdate
): Promise<IStandardAPIResponse<IActivityUpdate>> {
  try {
    let res = await httpClient<IActivityUpdate>(
      `activity-updates/${data._id}`,
      "PATCH",
      data
    );
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function deleteActivityUpdates(
  data: IActivityUpdate
): Promise<IStandardAPIResponse<IActivityUpdate>> {
  try {
    let res = await httpClient<IActivityUpdate>(
      `activity-updates/${data._id}`,
      "DELETE"
    );
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function getCustomerRackStatus(search: {
  customerId: string;
}): Promise<IStandardAPIResponse<IcustomerRackStatusObj>> {
  try {
    let res = await httpClient<IcustomerRackStatusObj>(
      `customer-rack-status`,
      "GET",
      search
    );
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function updateCustomerRackStatus(
  data: ICustomerRackStatus
): Promise<IStandardAPIResponse<ICustomerRackStatus>> {
  try {
    let res = await httpClient<ICustomerRackStatus>(
      `customer-rack-status`,
      "PATCH",
      data
    );
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function syncCustomerRackStatusFromCMT(data: {
  customerId: string;
  type: string;
}): Promise<IStandardAPIResponse<Array<ICustomerRackStatus>>> {
  try {
    let res = await httpClient<Array<ICustomerRackStatus>>(
      `sync-customer-rack-status/${data.customerId}/${data.type}`,
      "PATCH"
    );
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}
export async function generateOrUpdateCustomerReport(
  data: ICustomerReport
): Promise<IStandardAPIResponse<ICustomerReport>> {
  try {
    let res = await httpClient<ICustomerReport>(
      `customer-report`,
      "PATCH",
      data
    );
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}
export async function searchCustomerReport(data: {
  customerId: string;
  date: Date | string;
  datacenterId?: string;
}): Promise<IStandardAPIResponse<ICustomerReport>> {
  try {
    let res = await httpClient<ICustomerReport>(`customer-report`, "GET", data);
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}
export async function searchCustomerReportWorkFLowLogs(data: {
  customerReportId: string;
  status?: number[];
}): Promise<IStandardAPIResponse<Array<ICustomerReportWorkFlowLog>>> {
  try {
    let res = await httpClient<Array<ICustomerReportWorkFlowLog>>(
      `customer-report-workflow-log`,
      "POST",
      data
    );
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}
export async function sendReportToCustomer(data: {
  customerReportId: string;
  to: string;
  cc: string;
}): Promise<IStandardAPIResponse<any>> {
  try {
    let res = await httpClient<any>(`send-report-to-customer`, "POST", data);
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function getCustomerReportEmail(search: {
  customerId: string;
  datacenterId: string;
}): Promise<IStandardAPIResponse<ICustomerReportEmails>> {
  try {
    let res = await httpClient<ICustomerReportEmails>(
      `customer-report-emails`,
      "GET",
      search
    );
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function getMiscellaneousFiles(search: {
  date: Date | string;
  customerId: string;
}): Promise<IStandardAPIResponse<Array<IMiscellaneousFile>>> {
  try {
    let res = await httpClient<Array<IMiscellaneousFile>>(
      `miscellaneous-files`,
      "GET",
      search
    );
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function addMiscellaneousFile(
  data: IMiscellaneousFile[]
): Promise<IStandardAPIResponse<IMiscellaneousFile[]>> {
  try {
    let res = await httpClient<IMiscellaneousFile[]>(
      `miscellaneous-files`,
      "PUT",
      data
    );
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function updateMiscellaneousFile(
  data: IMiscellaneousFile
): Promise<IStandardAPIResponse<IMiscellaneousFile>> {
  try {
    let res = await httpClient<IMiscellaneousFile>(
      `miscellaneous-files/${data._id}`,
      "PATCH",
      data
    );
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function deleteMiscellaneousFile(
  data: IMiscellaneousFile
): Promise<IStandardAPIResponse<IMiscellaneousFile>> {
  try {
    let res = await httpClient<IMiscellaneousFile>(
      `miscellaneous-files/${data._id}`,
      "DELETE"
    );
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export const uploadMiscellaneousFile = async (file: File,type: 'misc' | 'power'): Promise<any> => {
  try {
    let res = await httpFileUpload<any>(
      `uploads-miscellaneous`,
      "POST",
      { file, data: { type } },
      true
    );
    return res;
  } catch (err: any) {
    return err && err.response ? err.response.data : undefined;
  }
};

export async function addOrUpdateCustomerConfig(
  data: ICustomerConfig
): Promise<IStandardAPIResponse<ICustomerConfig>> {
  try {
    let res = await httpClient<ICustomerConfig>(
      `customer-config`,
      "PATCH",
      data
    );
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function getCustomerConfig(searchObj: {
  customerId: string;
}): Promise<IStandardAPIResponse<Array<ICustomerConfig>>> {
  try {
    let res = await httpClient<Array<ICustomerConfig>>(
      `customer-config`,
      "GET",
      searchObj
    );
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function getCemApprovedDcForCustomer(searchObj: {
  customerId: string;
}): Promise<IStandardAPIResponse<Array<IDataCenter>>> {
  try {
    let res = await httpClient<Array<IDataCenter>>(
      `cem-approved-dc-for-customer`,
      "GET",
      searchObj
    );
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}
export async function getDCManagerApprovedDcForCustomer(searchObj: {
  customerId: string;
  date: Date | string;
}): Promise<IStandardAPIResponse<Array<IDataCenter>>> {
  try {
    let res = await httpClient<Array<IDataCenter>>(
      `dc-manager-approved-dc-for-customer`,
      "GET",
      searchObj
    );
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}
export async function downloadCustomerReport(
  searchObj: any
): Promise<IStandardAPIResponse<any>> {
  try {
    let res = await httpClient<any>(`mor-reports`, "GET", searchObj);
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

// newly added
export async function getAllCustomersByDC(search?: {
  datacenterIds?: string[];
  customerIds?: string[];
  search?: string;
}): Promise<IStandardAPIResponse<any>> {
  try {
    let res = await httpClient<any>(`customers-by-datacenters`, "POST", search);
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}
